// 项目管理员
const PROJECT_ADMIN = 10
// 项目联系人
const PROJECT_CONTACT = 11

// 课题管理员
const TOPIC_ADMIN = 20
// 课题联系人
const TOPIC_CONTACT = 21

// 单位管理员
const UNIT_ADMIN = 30
// 单位联系人
const UNIT_CONTACT = 31

// 成员
const MEMBER = 40

// 需要微软在线预览的文件type
const officeTypes = ['word', 'docx', 'doc', 'excel', 'xls', 'xlsx', 'ppt', 'pptx']
// 可以直接在浏览器打开的
const canPreview = ['pdf', 'png', 'jpg', 'image']

// 文件预览的方法
const previewFile = function (type, url) {
  // eslint-disable-next-line camelcase
  let path = ''
  if (officeTypes.includes(type)) {
    let origin = window.location.origin
    path = `${origin}/outer/previewFile?fileUrl=${url}/download`
  } else if (canPreview.includes(type)) {
    path = url
  } else {
    path = `${url}/download`
  }
  window.open(path, '_blank')
}

export default {
  PROJECT_ADMIN,
  PROJECT_CONTACT,
  TOPIC_ADMIN,
  TOPIC_CONTACT,
  UNIT_ADMIN,
  UNIT_CONTACT,
  MEMBER,
  officeTypes,
  canPreview,
  previewFile
}



// WEBPACK FOOTER //
// ./src/utils/global.js